// PrefetchKickoff — primes the SW caches for hill-side offline coverage.
// Mounted in SyncProvider (App.tsx) so it runs regardless of route entry.
//
// 2.5s setTimeout throttles the burst so it doesn't compete with first
// paint or the user's first interaction.

import { useEffect, useState } from "react";
import { useAppSync } from "../context";
import { useAudioPrefetch } from "./useAudioPrefetch";
import { useRegionTilePrefetch } from "./useRegionTilePrefetch";
import { env } from "../env";

export function PrefetchKickoff() {
  const { audios, regions } = useAppSync();
  const [prefetchOn, setPrefetchOn] = useState(false);

  useEffect(() => {
    const t = window.setTimeout(() => setPrefetchOn(true), 2500);
    return () => window.clearTimeout(t);
  }, []);

  // Hooks must be called unconditionally; gate with empty arrays.
  useAudioPrefetch(prefetchOn ? audios : []);
  useRegionTilePrefetch(regions, env.stadiaApiKey, prefetchOn);

  return null;
}
